import {
    SunOutlined,
    KeyboardOutlined,
    GuitarOutlined,
    DrumsOutlined,
    MicrophoneOutlined,
    GrandPianoOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { InstrumentFamily } from 'types/enums';

export const instrumentsToRender = [
    {
        icon: MicrophoneOutlined,
        description: t({
            message: `Vocals`,
            comment: 'From instruments cards group',
        }),
        pathname: `/instruments/${InstrumentFamily.Vocals}`,
    },
    {
        icon: DrumsOutlined,
        description: t({
            message: `Drums`,
            comment: 'From instruments cards group',
        }),
        pathname: `/instruments/${InstrumentFamily.Drums}`,
    },
    {
        icon: GuitarOutlined,
        description: t({
            message: `Guitars`,
            comment: 'From instruments cards group',
        }),
        pathname: `/instruments/${InstrumentFamily.Guitars}`,
    },
    {
        icon: KeyboardOutlined,
        description: t({
            message: `Synth`,
            comment: 'From instruments cards group',
        }),
        pathname: `/instruments/${InstrumentFamily.Synth}`,
    },
    {
        icon: GrandPianoOutlined,
        description: t({
            message: `Keys`,
            comment: 'From instruments cards group',
        }),
        pathname: `/instruments/${InstrumentFamily.Keys}`,
    },
    {
        icon: SunOutlined,
        description: 'FX',
        pathname: `/instruments/${InstrumentFamily.FX}`,
    },
];
